import Vue from 'vue';
import { isNil } from 'lodash';
import types from './mutation-types';

const mutations = {
  [types.SET_SELECTED](state, cardId) {
    Vue.set(state, 'selectedStoreCardId', cardId);
  },

  [types.SET_CARDS](state, cardList) {
    Vue.set(state, 'storeCardList', cardList);
  },

  [types.ADD_CARDS](state, cardList) {
    state.storeCardList.push(...cardList);
  },

  [types.SET_CARD_PAGES](state, { cardId, pageList }) {
    state.storeCardList.forEach((card) => {
      if (card.id === cardId && !isNil(card.store_card_id)) {
        Vue.set(card, 'pages', pageList);
      }
    });
  },

  [types.SET_PUB_CARD_PAGES](state, { cardId, pageList }) {
    state.storeCardList.forEach((card) => {
      if (card.id === cardId && isNil(card.store_card_id)) {
        Vue.set(card, 'pages', pageList);
      }
    });
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/store-cards/store/mutations.js